<!-- 示例页面 -->
<template>
  <div class="order-pages">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">验劵核销&nbsp;/&nbsp;</span>
      </div>
      <div>核销记录</div>
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header mb16">
            <div class="flex-row pt16">
              <el-input
                placeholder="请输入核销劵码"
                v-model="query.consumeCode"
                clearable
                class="w200"
              ></el-input>
            </div>
            <div class="flex-row pt16 ml10 mr10">
                <el-select v-model="query.orderSource" class="select" placeholder="核销渠道">
                  <el-option label="全部类型" value></el-option>
                  <el-option label="源思康" value="ysko2o"></el-option>
                  <el-option label="美团核销" value="meituan"></el-option>
                  <el-option label="口碑核销" value="koubei"></el-option>
                  <el-option label="联联核销" value="lianlian"></el-option>
                </el-select>
              </div>
            <div class="setDate pt16">
              <v-date @time="changeDate"></v-date>
            </div>
            <el-button type="primary" class="ml10 mt16" @click="searchDoQuery">搜索</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 260" header-cell-class-name="table_header_bgcolor">
              <el-table-column
                :prop="index"
                :align="item.align"
                :label="item.label"
                :width="item.width"
                :min-width="item.minWidth"
                :show-overflow-tooltip="false"
                v-for="(item,index) in columns"
                :key="index"
              >
                <template slot-scope="scope">
                  <div>{{Boolean(item.formatDay)?formatDate(scope.row[index]):scope.row[index]}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-link type="primary" @click="handleClick(scope.row)">订单信息</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editForm" @change="refreshPage"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import editSet from "./detail";
export default {
  mixins: [minxin],
  components: { editSet },
  data() {
    return {
      list: [],
      url: this.$url.order.list,
      columns: config.columns,
      query: {
        beginTime: new Date(),
        endTime: new Date(),
        orderSource: ''
      },
      height: this.$store.getters.MainHeight,
    };
  },
  created() {
    this.totalCounts();
  },
  mounted() {
    
  },
  methods: {
    back () {
      this.$router.push("/collectMoney/thirdOrder");
    },
    searchDoQuery() {
      this.query.start = 1
      this.totalCounts();
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    removeDoQuery() {
      this.query.customerName = "";
    },
    handleClick(item, index) {
      this.$refs["editForm"].$emit("set", item.id);
    },
    refreshPage(org) {
      if (org) {
        this.getData();
      }
    },
    totalCounts () {
      this.$api.post(this.$url.order.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  background: #fff;
  .member-header {
    padding: 0 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
}
</style>